import { State } from "./state";
import { storeInit } from "../../../Store";
const initialIpConfigOnReboot: State.Data = {
  ip: "",
  sn: "",
  gw: "",
  meth: "STATIC"
};

export const initial: State.Props = storeInit(initialIpConfigOnReboot);
export default initial;
